import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicModule } from './modules/public/public.module';
import { AuthGuardService } from './services/guards/auth-guard/auth-guard.service';
import { PageNotFoundComponent } from './modules/public/pages/page-not-found/page-not-found.component';

const routes: Routes = [
	{
		path: 'store',
		loadChildren: () => import('./modules/store/store.module').then(m => m.StoreModule)
	}, {
		path: 'brewery',
		loadChildren: () => import('./modules/store/store.module').then(m => m.StoreModule)
	}, {
		path: 'authentication',
		loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)
	}, {
		path: 'account',
		canActivate: [AuthGuardService],
		loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule)
	}, {
		path: 'administration',
		canActivate: [AuthGuardService],
		loadChildren: () => import('./modules/administration/administration.module').then(m => m.AdministrationModule)
	}, {
		path: 'guild',
		canActivate: [AuthGuardService],
		loadChildren: () => import('./modules/guilds/guilds.module').then(m => m.GuildsModule)
	// }, {
	// 	path: 'brewing',
	// 	canActivate: [AuthGuardService],
	// 	loadChildren: () => import('./modules/brewing/brewing.module').then(m => m.BrewingModule)
	}, {
		path: 'support',
		canActivate: [AuthGuardService],
		loadChildren: () => import('./modules/support/support.module').then(m => m.SupportModule)
	}, {
		path: 'integrations',
		canActivate: [AuthGuardService],
		loadChildren: () => import('./modules/integrations/integrations.module').then(m => m.IntegrationsModule)
	}, {
		path: 'knowledge',
		loadChildren: () => import('./modules/knowledge/knowledge.module').then(m => m.KnowledgeModule)
	},

	// Pollute the root
	{ path: 'register', redirectTo: 'authentication/register', pathMatch: 'full' },
	{ path: 'login', redirectTo: 'authentication/login', pathMatch: 'full' },
	{ path: 'logout', redirectTo: 'authentication/logout', pathMatch: 'full' },

	// Page Not Found
	{
		path: '**',
		// component: PublicContainerComponent,
		children: [
			{ path: '', component: PageNotFoundComponent }
		]
	}
];

@NgModule({
	imports: [
		PublicModule, // Load public module automatically
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
